import { Toolbox } from "@client/components/PageSkeleton/Toolbox";
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.HomePageTemplate) => {
    return (
        <PageSkeleton {...props.page}>
            <Toolbox value={props.page.body.value} />
        </PageSkeleton>
    );
};
